import { Component } from '@angular/core';

@Component({
  selector: 'sura-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent { }
